import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openMarketingChannelsSubmenu } from '../sidebarHelpers';

const createSmsAndViber = (baseUrl, navigate, user) => {
  return {
    id: 'createSmsAndViber',
    title: 'Create SMS/Viber message (optional)',
    steps: [
      {
        selector: '[data-tour="marketingChannelsLink"]',
        content: <p>Click on the "Marketing Channels" menu item in the navigation.</p>,
      },
      {
        actionBefore: () => openMarketingChannelsSubmenu('[data-tour="viberLink"]'),
        selector: '[data-tour="viberLink"]',
        content: (
          <>
            <p>Sending text messages and Viber campaigns is optional and subject to a separate subscription.</p>
            <p>To request one of these subscriptions you can contact us at: shopify-support@releva.ai</p>
          </>
        ),
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/guide`, true);
        },
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find((a) => a.action === 'taskCompleted' && a.context.task === 'createSmsAndViber'),
  };
};

export default createSmsAndViber;
